import { ReactNode, createContext, useEffect, useState } from "react";
import { IUserInfoContextType } from "../interfaces/IUserInfoContextType";
import { IUserInfo } from "../interfaces/IUserInfo";
import { useAuthenticationContext } from "../hooks/useAuthenticationContext";
import { useErrorContext } from "../hooks/useErrorContext";
import { Box, CircularProgress } from "@mui/material";

//The userinfo context object holds the latest IUserInfoContextType.
export const UserInfoContext = createContext<IUserInfoContextType | undefined>(undefined);

//This component is responsible to manage the user info and provide it through the application component tree.
export const UserInfoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [userInfo, setUserInfo] = useState<IUserInfo | undefined>(undefined);
    const { cstKey } = useAuthenticationContext();
    const { setError } = useErrorContext();
    const [loading, setLoading] = useState<boolean>(true);
    const USERINFO_URI = process.env.REACT_APP_USERINFO_CONTROLLER;

    const handleError = (message: string | null, statusCode: number) => {
        setError({ message, statusCode });
        setLoading(false);
    };

    //Function to fetch user info data using the user info api endpoint.
    const UserInfoControllerFetch = async () => {
        const apiUserInfo = `${USERINFO_URI}?customerKey=${cstKey}`;
        try {
           setLoading(true);
           const response = await fetch(apiUserInfo);
           if (!response.ok) {
               console.log("getUserInfo", response.statusText);
               setLoading(false);
           }
           const result = await response.json();
           if (!result) {
               return handleError(null, 1);
           }
           else {
               setUserInfo(result.UserInfo);
           }
        } catch (error: any) {
           console.log('getUserInfo error', error);
           handleError(null, error.status);
        } finally {
           setLoading(false);
        }
    };

    useEffect(() => {
        if (cstKey !== null && cstKey !== undefined) {
            UserInfoControllerFetch();
        }
        else {
            setLoading(false);
        }
    }, [cstKey]);

    const value = {
        userInfo
    }

    return (
        <UserInfoContext.Provider value={value}>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="30vh">
                    <CircularProgress />
                </Box>
            ) : (
                children
            )}
        </UserInfoContext.Provider>
    );
}